var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var AnalyticsPulseIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("polygon", { points: "6.02881486 11.669719 4.31052663 14.2237143 0 14.2237143 0 12.072968 2.95505632 12.072968 6.08171526 7.42562645 9.14210147 12.2131553 13.6797309 2 16.9876554 15.0354663 18.3920183 12.072968 24 12.072968 24 14.2237143 19.9800473 14.2237143 16.2937238 22 13.0522795 9.22651029 9.53197471 17.1499027" })))); };
export var AnalyticsPulse = styled(AnalyticsPulseIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=AnalyticsPulse.js.map